export default "__VITE_ASSET__BFSc18JK__"